import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const color = ["warning", "primary", "success", "info"][
    Math.floor(Math.random() * 3)
  ]

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center">
            <div className="avatar-sm">
              <span
                className={
                  "avatar-title rounded-circle bg-soft bg-" +
                  color +
                  " text-" +
                  color +
                  " font-size-18"
                }
                alt="Header Avatar"
              >
                {props.currentUser &&
                  props.currentUser.name &&
                  props.currentUser.name.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="d-none d-xl-inline-block ms-2 me-1">
              {props.currentUser.name}
            </div>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem>
            <Link to="" className="text-light">
              <i className="bx bx-lock-open font-size-16 align-middle me-1" />
              <span>{"Edit Profile"}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to="/change-password" className="text-light">
              <i className="bx bx-lock-open font-size-16 align-middle me-1" />
              <span>{"Change Password"}</span>
            </Link>
          </DropdownItem>
          <DropdownItem>
            <Link to="" className="text-white">
              <i className="bx bx-lock-open font-size-16 align-middle me-1" />
              <span>{"Switch Profile"}</span>
            </Link>
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/api/auth/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger " />
            <span>{"Logout"}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}
const mapStatetoProps = store => {
  return {
    currentUser: _.get(store, "currentUser.currentUser.data"),
  }
}

export default withRouter(connect(mapStatetoProps, {})(ProfileMenu))
